import {PAGES} from "../../../../../core/consts";
import {BaseLinkModel} from "../../../../../infrastructure/models/link/base-link-model";
import {CompetitionLinkParams} from "../../../models/competition-link-params";

export class CompetitionMedalsPageLinkModel extends BaseLinkModel  {
  constructor(competitionId, sportName, competitionName, isFollow: Boolean = true) {
    super(PAGES.COMPETITION.medals, new CompetitionLinkParams(competitionId, sportName, competitionName), false, null, null);

    this.isFollow = isFollow;
  }
}